import React, {FC} from "react";
import Controls from "./Controls";
import Input from "./Input";
import {ArcState} from "./CreateArcModal";

interface ArcControlsProps {
    object: ArcState;
    onModifyObject: (params: Partial<ArcState>) => void;
    onHide: () => void;
}

const ArcControls: FC<ArcControlsProps> = ({
                                               object,
                                               onModifyObject,
                                               onHide
                                           }) => {
    const changeX = (x: string) => onModifyObject({x: Number(x)});
    const changeY = (y: string) => onModifyObject({y: Number(y)});
    const changeRadius = (radius: string) => onModifyObject({radius: Number(radius)});
    const changeStartAngle = (startAngle: string) => onModifyObject({startAngle: Number(startAngle)});
    const changeEndAngle = (endAngle: string) => onModifyObject({endAngle: Number(endAngle)});
    const changeAnticlockwise = (anticlockwise: boolean) => onModifyObject({anticlockwise: anticlockwise});
    const changeStroke = (stroke: string) => onModifyObject({stroke: stroke});
    const changeFill = (fill: string) => onModifyObject({fill: fill});
    return (
        <Controls title="Arc Controls" onHide={onHide}>
            <form className="controls-form">
                <Input label="x" type="number" value={String(object.x)} onChange={changeX}/>
                <Input label="y" type="number" value={String(object.y)} onChange={changeY}/>
                <Input label="radius" type="number" value={String(object.radius)} onChange={changeRadius}/>
                <Input label="startAngle" type="number" value={String(object.startAngle)} onChange={changeStartAngle}/>
                <Input label="endAngle" type="number" value={String(object.endAngle)} onChange={changeEndAngle}/>
                <Input label="anticlockwise" type="checkbox" value={String(object.anticlockwise)}
                       onChecked={changeAnticlockwise}/>
                <Input label="stroke" type="color" value={String(object.stroke)} onChange={changeStroke}/>
                <Input label="fill" type="color" value={String(object.fill)} onChange={changeFill}/>
            </form>
        </Controls>
    );
};

export default ArcControls;